import { StatCard } from "../../common/StatCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DonationImpactCards(_ref) {
  let {
    totals = {
      totalDonations: 0,
      totalUniqueContributions: 0,
      totalProjectsFunded: 0
    }
  } = _ref;
  const totalDonations = totals.totalDonations.toFixed(2).toString();
  const totalUniqueContributions = totals.totalUniqueContributions.toString();
  const totalProjectsFunded = totals.totalProjectsFunded.toString();
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-6",
    children: [/*#__PURE__*/_jsx("div", {
      className: "text-2xl font-sans",
      children: "Donation Impact"
    }), /*#__PURE__*/_jsxs("div", {
      className: "grid grid-cols-2 grid-row-2 lg:grid-cols-3 lg:grid-row-1 gap-6",
      children: [/*#__PURE__*/_jsx("div", {
        className: "col-span-2 lg:col-span-1",
        children: /*#__PURE__*/_jsx(StatCard, {
          title: "Total Donations",
          value: "$" + totalDonations
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-span-1",
        children: /*#__PURE__*/_jsx(StatCard, {
          title: "Contributions",
          value: totalUniqueContributions
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-span-1",
        children: /*#__PURE__*/_jsx(StatCard, {
          title: "Projects Funded",
          value: totalProjectsFunded
        })
      })]
    })]
  });
}